module.exports = __webpack_public_path__ + "img/logo.addc1dfc.png";